import React, { useRef, useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { apiFetch } from "../../../utils/http";
import ClienteMultiSelect from "../../../components/multiselect/ClienteMultiSelect";

export default function AsignarLimiteDeCreditoMasivo() {
  const fileInputRef = useRef(null);

  const [clienteIds, setClienteIds] = useState([]);
  const [descargando, setDescargando] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [errores, setErrores] = useState([]);

  async function descargarExcel() {
    setMensaje("");
    setErrores([]);

    if (!clienteIds.length) {
      setMensaje("Debe seleccionar al menos un cliente.");
      return;
    }

    setDescargando(true);

    try {
      const res = await apiFetch(apiRoutes.tarjetas.limitesMasivo.exportar(clienteIds));

      if (!res.ok) {
        let msg = "No se pudo generar el Excel.";

        try {
          const data = await res.json();
          msg = data?.message || data?.error || msg;
        } catch (_) {}

        throw new Error(msg);
      }

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "Limites_Tarjetas.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);

      setMensaje("Excel generado correctamente.");
    } catch (e) {
      console.error(e);
      setMensaje(e?.message || "Error generando Excel.");
    } finally {
      setDescargando(false);
    }
  }

  function abrirSelectorArchivo() {
    setMensaje("");
    setErrores([]);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
      fileInputRef.current.click();
    }
  }

  async function procesarArchivo(file) {
    if (!file) return;

    setMensaje("");
    setErrores([]);
    setCargando(true);

    try {
      const formData = new FormData();
      formData.append("file", file);

      const res = await apiFetch(apiRoutes.tarjetas.limitesMasivo.importar, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.message || data?.error || "No se pudo procesar el Excel.");
      }

      setMensaje(
        `Proceso finalizado. Leídas: ${data.totalLeidas ?? 0}, actualizadas: ${
          data.actualizadas ?? 0
        }, errores: ${data.conError ?? 0}.`
      );

      setErrores(data.errores || []);
    } catch (e) {
      console.error(e);
      setMensaje(e?.message || "Error procesando Excel.");
    } finally {
      setCargando(false);
    }
  }

  return (
    <div className="p-4">
      <div className="bg-white rounded shadow p-4 max-w-5xl">
        <h1 className="text-xl font-semibold mb-4">
          Asignar límite de crédito masivo
        </h1>

        <p className="text-sm text-gray-600 mb-5">
          Seleccione uno o más clientes, descargue el Excel, modifique la columna
          de límite de crédito y luego cargue el archivo para impactar los cambios.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_auto] gap-4 items-end">
          <div>
            <label className="label">Clientes</label>

            <ClienteMultiSelect
              value={clienteIds}
              onChange={setClienteIds}
              disabled={descargando || cargando}
            />
          </div>

          <button
            type="button"
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 disabled:opacity-60"
            onClick={descargarExcel}
            disabled={descargando || cargando || clienteIds.length === 0}
          >
            {descargando ? "Descargando..." : "Descargar Excel"}
          </button>

          <button
            type="button"
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 disabled:opacity-60"
            onClick={abrirSelectorArchivo}
            disabled={descargando || cargando}
          >
            {cargando ? "Procesando..." : "Cargar Excel"}
          </button>

          <input
            ref={fileInputRef}
            type="file"
            accept=".xlsx"
            className="hidden"
            onChange={(e) => procesarArchivo(e.target.files?.[0])}
          />
        </div>

        {mensaje && (
          <div className="mt-5 border rounded p-3 bg-gray-50 text-sm">
            {mensaje}
          </div>
        )}

        {errores.length > 0 && (
          <div className="mt-4 border rounded p-3 bg-red-50 text-sm text-red-700">
            <div className="font-semibold mb-2">Errores detectados:</div>

            <ul className="list-disc pl-5 space-y-1 max-h-64 overflow-auto">
              {errores.map((err, idx) => (
                <li key={idx}>{err}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}